import React from "react";
import { pricing } from "../mock";
import { Check, ArrowRight } from "lucide-react";

function PackageCard({ pkg }) {
  return (
    <div
      className={`service-card p-8 border ${
        pkg.featured
          ? "bg-neutral-900 text-[#fbf3e4] border-neutral-900"
          : "bg-white border-neutral-200 text-neutral-900"
      }`}
    >
      {pkg.featured && (
        <div className="inline-block text-[10px] tracking-[0.3em] bg-[#fbf3e4] text-neutral-900 px-3 py-1 mb-5">
          MOST POPULAR
        </div>
      )}
      <h4 className="font-display text-2xl tracking-wide">{pkg.name}</h4>
      <div className="mt-5 flex items-baseline gap-2">
        <span className={`text-xs ${pkg.featured ? "text-neutral-400" : "text-neutral-500"}`}>from</span>
        <span className="font-display text-5xl">{pkg.from}</span>
        <span className={`text-sm ${pkg.featured ? "text-neutral-300" : "text-neutral-600"}`}>
          {pkg.unit}
        </span>
      </div>
      <ul className="mt-7 space-y-3">
        {pkg.highlights.map((h) => (
          <li key={h} className="flex items-start gap-3 text-sm">
            <span
              className={`mt-0.5 w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 ${
                pkg.featured ? "bg-[#fbf3e4] text-neutral-900" : "bg-neutral-900 text-[#fbf3e4]"
              }`}
            >
              <Check size={10} />
            </span>
            <span className={pkg.featured ? "text-neutral-200" : "text-neutral-800"}>{h}</span>
          </li>
        ))}
      </ul>
      <p className={`mt-6 text-xs ${pkg.featured ? "text-neutral-400" : "text-neutral-500"}`}>{pkg.note}</p>
      <a
        href="#contact"
        className={`btn-primary mt-8 inline-flex items-center gap-2 px-5 py-3 text-sm font-medium tracking-wide w-full justify-center ${
          pkg.featured
            ? "bg-[#fbf3e4] text-neutral-900 hover:bg-white"
            : "bg-neutral-900 text-[#fbf3e4] hover:bg-neutral-700"
        }`}
      >
        Request Quote <ArrowRight size={14} />
      </a>
    </div>
  );
}

export default function Packages() {
  return (
    <section id="packages" className="bg-[#fbf3e4] py-24 lg:py-32 border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">PACKAGES</p>
          <h3 className="font-display text-4xl md:text-6xl leading-[1] text-neutral-900">
            Indicative pricing
          </h3>
          <p className="mt-6 text-neutral-700 text-lg leading-relaxed">
            Every booking is quoted individually based on the menu, guest count and location. Below is a starting
            guide so you know what to expect.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pricing.map((p) => (
            <PackageCard key={p.id} pkg={p} />
          ))}
        </div>

        <p className="text-center text-sm text-neutral-500 mt-10">
          Prices exclude ingredients where applicable. Travel outside Stoke-on-Trent / Manchester quoted separately.
        </p>
      </div>
    </section>
  );
}
